export default {
  loading: "กำลังโหลด...",
  open: "เปิด",
  close: "ปิด",
  stake: "เงินที่วางเดิมพัน",
  crdr: "ชนะ/เสีย",
  item: "ไอเทม",
  valid: "ถูกต้อง",
  home_preferences: "หน้าแรกตั้งค่าตัวเลือก",
  quick_links: "ลิงค์ด่วน",
  language: "ภาษา",
  home_page: "หน้าแรก",
  favorites: "แต้มต่อ",
  note: "หมายเหต",
  my_bets: "บิลเดิมพัน",
  my_account: "บัญชีของฉัน",
  contact_us: "ติดต่อเรา",
  report: "รายงาน",
  help_support: "ช่วยเหลือและสนับสนุน",
  currency: "สกุลเงิน",
  others: "อื่นๆ",
  welcome: "ยินดีต้อนรับ",
  account_id: "ชื่อผู้ใช้",
  password: "รหัสผ่าน",
  account: "บัญชี",
  all_sports: "กีฬาทั้งหมด",
  my_sports: "กีฬา",
  action: "แอ็คชั่น",
  accept_better_odds: "ยอมรับอัตราเดิมพันที่ดีกว่า",
  accept_any_odds: "รับค่าเป็นต่อ ทุกค่า",
  auto_refresh_odds: "รีเฟรชอัตโนมัติ",
  auto_refresh: "รีเฟรชอัตโนมัติ",
  auto_refreshing: "อัตโนมัติกำลังอัพเดต......",
  all_markets: "ตลาดทั้งหมด",
  available_balance: "ยอดเงินคงเหลือ",
  athletics: "กรีฑา",
  american_football: "อเมริกันฟุตบอล",
  aussie_rules_football: "กติกาออสซีย์",
  gmail: "Gmail",
  contact_number: "เบอร์ติดต่อ",

  away: "ทีมเยือน",

  all: "ทั้งหมด",
  accepted: "ยอมรับ",
  add: "เพิ่ม",
  add_homescreen: "เพิ่มในหน้าจอหลัก",
  abandoned: "ถถูกยกเลิก",

  bet_slip: "บิลเดิมพัน",
  bet_credit: "เครดิตพนัน",
  bet_list: "รายการ",
  betting: "การเดิมพัน",
  balance: "ยอดคงเหลือ",

  betting_statement: "ย้อนดูรายการเดิมพันที่เล่นไปแล้ว",
  betting_rules: "กติกาการเดิมพัน",
  bet_types: "ประเภทของการเดิมพัน",
  bs: "ใหญ่/เล็ก",
  bet_summary: "สรุปการเดิมพัน",
  bets: "เดิมพัน",
  basketball: "บาสเกตบอล",
  baseball: "เบสบอล",
  badminton: "แบดมินตัน",
  bandy: "บันดี้",
  boxing: "มวย",
  beach_soccer: "ฟุตบอลชายหาด",

  casino: "คาสิโน",
  cash_balance: "ยอดเงินสดคงเหลือ",
  change_account_password: "เปลี่ยนรหัสผ่านบัญชี",
  current_password: "กรุณายืนยันรหัสที่ใช้ปัจจุบัน",
  confirm_new_password: "ยืนยันรหัสในการเข้าระบบ",
  customize_sports_order: "กำหนดคำสั่งด้านกีฬา",
  choice: "รายการ",
  credit: "ได้",
  commission: "คอมมิชชั่น",
  customize: "ปรับแต่ง",
  cancel: "ยกเลิก",
  confirmation: "การยืนยัน",
  continue_bet: "เดิมพันต่อ",
  customer_service: "สายด่วนฝ่ายบริการลูกค้า",
  cricket: "คริกเก็ต",
  cycling: "จักรยาน",
  copa_america: "โกปาอาเมริกา",
  combinations: "การรวมกัน",
  create_room: "สร้างห้อง",

  darts: "ยิงเป้า",
  debit: "เสีย",
  display_language: "ภาษาที่แสดง",
  default_event_sorting: "การเรียงลำดับกิจกรรมตามค่าเริ่มต้น",
  default_stake: "ค่าเดิมพันตั้งต้น",
  date: "วันที่",
  draw: "เสมอ",
  draw_cancel: "เสมอ",
  dec: "DEC",
  double_line: "แถวคู่",
  disable: "ปิดการใช้งาน",
  dec_odds: "DEC | การเดิมพันแบบมีทศนิยม",
  id_odds: "IND | แบบอินโด",
  double_chance: "สองโอกาส",
  details: "รายละเอียด",

  enable: "เปิด",
  event_sorting: "เรียงลำดับเหตุการณ์",
  e_sports: "อี-สปอร์ต",
  esports2: "อี-สปอร์ต 2",
  edit: "แก้ไข",
  early: "ล่วงหน้า",
  event: "รายการ",
  even: "คู่",
  email: "อีเมล",
  esports: "อี-สปอร์ต",
  euro: "ยูโร 2020",
  entry_fee: "ค่าแรกเข้า",
  exclusive: "Exclusive",
  event_worldcup: "Worldcup",
  event_euro: "EURO 2024",
  event_copa: "COPA 2024",
  event_olympic: "Olympic 2024",
  event_club_worldcup: "CLUB WORLD CUP",
  event_women_euro: "WOMEN's EURO",
  event_nation_league: "NATION LEAGUE",
  event_fifa_club: "FIFA CLUB",

  es_101: "Map 1",
  es_102: "Map 2",
  es_103: "Map 3",
  es_104: "Map 4",
  es_105: "Map 5",
  es_106: "Map 6",
  es_107: "Map 7",
  es_108: "Map 8",
  es_109: "Map 9",
  es_110: "Map 10",
  euroDate: "12 JUNE - 12 JULY",
  exclusive: "พิเศษ",

  fd_101: "1ST Prize",
  fd_102: "2ND Prize",
  fd_103: "3RD Prize",

  first_goal: "ประตูแรก",
  first_half: "ผลการแข่งขันครึ่งแรก",
  final: "ผลการแข่งขัน",
  full_time: "เต็มเวลา",
  fold: "-เท่า",
  from: "จาก",
  field_hockey: "ฮ็อกกี้สนาม",
  futsal: "ฟุตซอล",
  fd: "4D Special",
  fishing: "Fishing",

  gaelic_football: "แกลิคฟุตบอล",
  golf: "กอล์ฟ",
  games: "เกม",
  given_credit: "ให้เครดิต",
  group: "กลุ่ม",
  goal: "ทำประตู",
  general: "ทั่วไป",
  general_betting_rules: "กฎการเดิมพันทั่วไป",
  general_rules_market: "กฏกติกาของตลาด (ประเภทการเดิมพันกฎกติกาทั่วไป๗)",

  half_time: "ครึ่งแรก",
  hide_header: "หัวข้อ",
  hk: "HK",
  hk_odds: "HK | แบบฮ่องกง",
  hdp: "แฮนดิแคป",
  home: "หน้าแรก",
  hotline: "สายด่วน",
  handball: "แฮนด์บอล",
  hurling: "เฮอร์ลิง",
  hour: "ชั่วโมง",
  highlight: "ไฮไลท์",

  id: "ID",
  ice_hockey: "ฮอกกี้น้ำแข็ง",

  joined: "เข้าร่วมเท่านั้น",
  join_now: "เข้าร่วมทันที",
  jackpot: "แจ็คพอต",

  keno: "คีโน่",
  kickoff: "ที่เริ่มแข่งขัน",
  kabbadi: "กีฬากาบัดดี้",
  kof: "King of Figthers",
  ko: "K.O By",

  lose: "เสีย",
  lose_half: "เสียครึ่ง",
  lottery: "ลอตเตอรี",
  login: "เข้าสู่ระบบ",
  logout: "ออกจากระบบ",
  last_login: "การเข้าสู่ระบบครั้งล่าสุด",
  last_transaction: "รายการเล่นสุดท้าย",
  live_streaming: "เปิดให้บริการถ่ายทอดสด",
  live_match: "การจับคู่ถ่ายทอดสด",
  live_chat: "พูดคุยสด",
  live: "สด",
  live_tv: "ถ่ายทอดสดทางทีวี",
  livecasino: "คาสิโนสด",
  loss: "แพ้",
  lost: "เสีย",
  last_bet: "เดิมพันสุดท้าย",
  last_goal: "ประตูสุดท้าย",
  leave_room: "ออกจากห้อง",
  last_betting_time: "เวลาเดิมพันล่าสุด",
  lose_all: "แพ้ทั้งหมด",

  mobile: "สมาร์ทแอฟ",
  message: "ข้อความ",
  my_bet: "บิลเดิมพัน",
  my_favorites: "รายการโปรดของฉัน",
  market_type: "ประเภทตลาด",
  match: "รายการแข่งขัน",
  message_history: "ประวัติข้อมูลที่บันทึก",
  my: "MY",
  market: "ตลาด",
  main_markets: "ตลาดหลัก",
  my_odds: "MY | แบบมาเลย์",
  min: "ขั้นต่ำ",
  max: "สูงสุด",
  max_payout: "จ่ายสูงสุด",
  main: "หลัก",
  corners: "เตะมุม/การ์ด",
  specials: "สเปเชี่ยล",
  mix_parlay: "มิกซ์ พาร์เลย์",
  mma: "ศิลปะการต่อสู้แบบผสม (MMA) ",
  motorsports: "โมโตสปอร์ต",
  muay_thai: "มวยไทย",
  map1: "Map 1",
  map2: "Map 2",
  map3: "Map 3",
  map4: "Map 4",
  map5: "Map 5",
  map6: "Map 6",
  map7: "Map 7",
  map8: "Map 8",
  map9: "Map 9",
  matches: "แมตช์",
  mini_arcade: "Mini Arcade",
  match_started: "-",

  no_goal: "ไม่มีประตู",
  normal_announcements: "ประกาศปกติ",
  nickname: "ตั้งชื่อเล่น",
  new_password: "รหัสผ่านใหม่",
  new: "ใหม่",
  no: "ลำดับ",
  normal_sorting: "เรียงตามลีก",
  netball: "กีฬาสำหรับเด็กหญิงคล้ายฟุตบอ",
  newsinfo: "ข่าว",
  next: "ถัดไป",

  olympic: "การแข่งขันกีฬาโอลิมปิก",
  other_markets: "การเดิมพันอื่น ๆ",
  outstanding: "การเดิมพันที่ยังไม่สิ้นสุด",
  odds_type: "ประเภทอัตราเดิมพัน",
  odds: "อัตราเดิมพัน",
  opening_balance: "ยอดคงเหลือก่อนหน้านี้ ",
  outright: "ทายผลผู้ชนะ",
  oe: "คี่/คู่",
  on: "เปิด",
  off: "ปิด",
  outstanding_bet: "รายการเดิมพันที่เล่นค้างไว้",
  over: "สูง",
  odd: "คี่",
  official_link: "ลิงค์อย่างเป็นทางการ",
  owner: "เจ้าของห้อง",

  password_expiry: "วันหมดอายุของรหัส",
  parlay: "พาร์เลย์",
  parlay_early: "พาร์เลย์ ล่วงหน้า",
  mmo_parlay: "เมียนมาร์พาร์เลย์",
  mmo_odds: "อัตราต่อรองพม่า",
  page_display: "หน้าที่แสดง",
  page_type: "ประเภทหน้าเว็บ",
  page_size: "ขนาดหน้าเว็บ",
  personal_message: "ข้อความส่วนตัว",
  process_bet: "วางเดิมพัน",
  payout: "จ่าย",
  pending: "กำลังรอ",
  personal: "ส่วนบุคคล",
  play_now: "เล่นเลย",
  parlay_generator: "Parlay Generator",
  private: "ส่วนตัว",
  pool: "จ่าย $",
  players: "ผู้เล่น",
  points: "แต้ม",
  prize: "รางวัล",
  play_to_earn: "เล่นเพื่อรับ",
  
  quick_bet: "เดิมพันด่วน",
  qq: "QQ",

  room: "ห้อง",
  result: "ผลลัพธ์",
  restore: "ฟื้นฟู",
  remark: "ข้อสังเกตุ",
  ref_no: "Ref No.",
  remove_from_parlay: "ลบออกจาก parlay",
  running: "กำลังแข่งขัน",
  reject: "ศยกเลิก",
  rugby: "รักบี้",
  roundof16: "รอบ 16",
  quater_finals: "รอบก่อนรองชนะเลิศ",
  semi_finals: "รอบรองชนะเลิศ",
  room_id: "รหัสห้อง",
  refund: "คืนเงิน",

  skype: "Skype",
  sports: "กีฬา",
  show_balance: "แสดงยอดคงเหลือ",
  statement: "ประวัติการเล่น",
  settings: "ตั้งค่า",
  search_team: "ค้นหาทีม",
  show_header: "โชว์หัวข้อ",
  submit: "ตกลง",
  set_nickname: "ตั้งชื่อเล่น",
  single: "เดียว",
  save: "บันทึก",
  show_score_map: "แสดงแผนผังคะแนน",
  status: "สถานะ",
  sort: "ประเภท",
  sportsbook: "กีฬา",
  sum: "SUM",
  special_announcements: "ประกาศพิเศษ",
  subtotal: "จำนวนรวมย่อย",
  single_line: "แถวเดี่ยว",
  sort_by_time: "เรียงตามเวลา",
  slots: "สล็อต",
  select_leagues: "เลือกลีก",
  special: "พิเศษ",
  scroll_bottom: "แตะเพื่อเลื่อนไปยังพื้นที่การเดิมพัน",
  swipe_to_search: "ปัดเพื่อค้นหา",
  soccer: "ฟุตบอล",
  squash: "สควอช",
  sepak_takraw: "เซปักตะกร้อ",
  snooker: "สนุ๊กเกอร์/พูล",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "Macau Suite",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  suite_sexy: "Sexy Casino",
  sfv_101: "Round 1",
  sfv_102: "Round 2",
  sfv_103: "Round 3",
  sfv_104: "Round 4",
  sfv_105: "Round 5",
  settlement: "สรุปยอด",
  settled_amount: "จำนวนเงินที่ชำระ",
  search: "ค้นหา",
  settled: "สรุปยอด",
  sysparlay: "เดิมพันระบบ",
  stake_per_bet: "เดิมพันเดี่ยว",
  score: "คะแนน",
  winner: "ผู้ชนะ",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pramagtic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  slot_epw: "Epicwin",
  selected: "เลือกแล้ว",
  select_matches: "เลือกแมตช์",

  turnover: "ยอดรวมของการเล่น",
  today: "วันนี้",
  time: "เวลา",
  team: "ทีม",
  to: "ถึง",
  trans_time: "หมายเลขบิล",
  total: "จำนวนรวม",
  total_goal: "ประตูรวม",
  treble: "ทริปเปิ้ล",
  total_bets: "เดิมพันทั้งหมด",
  tnc: "ข้อกำหนดและเงื่อนไขทั่วไป",
  tennis: "เทนนิส",
  table_tennis: "ปิงปอง",
  telegram: "Telegram",
  total_stake: "เงินเดิมพันทั้งหมด",
  tournament: "ทัวร์นาเมนต์",
  tomorrow: "พรุ่งนี้",
  total_points: "คะแนนรวม",
  tournament_refund: "การคืนเงินทัวร์นาเมนต์",

  under: "ต่ำ",
  void: "โมฆะ",
  volleyball: "วอลเลย์บอล",
  void_list: "เดิมพันเป็นโมฆะ",
  view_odds: "ดูราคาต่อรอง",
  video: "วิดีโอ",

  won_all: "ชนะทั้งหมด",
  won_half: "ชนะครึ่ง",
  win_half: "ชนะครึ่ง",
  win: "ชนะ",
  won: "ชนะ",
  waiting: "กำลังรอ",
  wechat: "Wechat",
  whatsapp: "Whatsapp",
  winter_sports: "กีฬาฤดูหนาว",
  water_polo: "โปโลน้ำ",
  winlose: "ชนะ/เสีย",
  winner_rank: "อันดับผู้ชนะ",

  yes: "ใช่",
  no: "ไม่",

  yesterday: "เมื่อวาน",
  monday: "จันทร์",
  tuesday: "อังคาร",
  wednesday: "พุธ",
  thursday: "พฤหัสบดี",
  friday: "ศุกร์",
  saturday: "เสาร์",
  sunday: "อาทิตย์",

  all_league: "ทั้งหมด",
  match_completed: "สมบูรณ์",
  match_pending: "รอผล",
  match_cancelled: "คืนเงิน",
  match_cancelled_1h: "คืนเงิน 1H",
  match_cancelled_2h: "คืนเงิน 2H",
  match_suspended: "ถูกยกเลิก",
  match_suspended_1h: "ถูกยกเลิก 1H",
  match_suspended_2h: "ถูกยกเลิก 2H",

  check_all: "เลือกทั้งหมด",
  selected_only: "ที่เลือกไว้",
  filtered: "กรอง",
  turn_on: "เปิด",
  turn_off: "ปิด",

  more_bet_types: "ประเภทการเดิมพันเพิ่มเติม",
  switch_to_desktop: "สลับเป็นเดสก์ท็อป",

  events: "รายการ",
  brackets: "สาย",
  standing: "กลุ่ม",

  big_small: "ใหญ่/เล็ก",
  odd_even: "คู่/คี่",

  first_digit: "1st Digit",
  second_digit: "2nd Digit",
  third_digit: "3rd Digit",
  forth_digit: "4th Digit",
  total_4d: "Total 4D",
  total_3d: "Total of Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",
  total_winlose: "ชนะ/แพ้ทั้งหมด",

  news: "ข่าว",
  more: "เพิ่มเติม",
  settled_remark: "หมายเหตุ: การเดิมพันตั้งแต่วันนี้จะปรากฏขึ้น",
  w4d: "4D",
  deselect_all: "ยกเลิกการเลือกทั้งหมด",
  select_all: "เลือกทั้งหมด",
  done: "เสร็จแล้ว",
  tutorial_tooltips: "วิธีติดตั้งแอปนี้บนหน้าจอหลัก",
  tutorial: "คู่มือ",
  dismiss: "ยกเลิก",

  seven_days: "7 วันที่ผ่านมา",
  fourteen_days: "14 วันที่ผ่านมา",

  hide: "ซ่อน",
  more_details: "รายละเอียดเพิ่มเติม",
  goto_statement: "ไปที่คำชี้แจง",

  current_live: "สด",
  upcoming: "วันนี้",
  prematch: "รายการแข่งขัน",
  desktop_view: "ดูแบบเดสก์ท็อป",
  back_to_lobby: "กลับล็อบบี้",

  bet: "เดิมพัน",
  comm: "คอมมิชชั่น",
  early_all: "ล่วงหน้า (ทั้งหมด)",
  more_markets: "ตลาดอื่นๆ",
  go_today_matches: "รายการวันนี้",
  go_live_matches: "ถ่ายทอดสด",
  remember_stake: "จำค่าเดิมพัน",
  confirm: "ยืนยัน",
  parlay_slip: "บิลพาร์เลย์",
  parlay_slip_selection: "การเลือกบิลพาร์เลย์",
  remove_all: "ลบทั้งหมด",
  add_more_selection: "เพิ่มการเลือกเพิ่มเติม",
  retain_selections: "เก็บส่วนที่เลือก",
  transfer: "โอนย้าย",
  no_record: "ไม่พบข้อมูล",
  no_bet: "ไม่มีเดิมพัน",

  random_pick: "Generate",
  add_pick: "เพิ่มในสลิปพนัน",

  worldcup: "WORLD CUP 2022",
  time_remaining: "เวลาที่เหลือ",

  slot_championstar: "Champion Star",
  slot_fifafiesta: "Fifa Fiesta",
  slot_penaltymania: "Penalty Mania",
  minigame_dragon: "Dragon's Treasure",
  minigame_illuvium: "Illuvium Master",
  minigame_mobo: "Mobox Olympia",

  egames: "V-Games",
  feedback: "ความคิดเห็นผู้ใช้บริการ",
  ranking: "อันดับ",
  total_winning: "ชัยชนะทั้งหมด",
  first_prize: "รางวัลชนะเลิศ",
  second_prize: "รางวัลอันดับสอง",
  third_prize: "รางวัลอันดับสาม",
  place: "อันดับ",
  current_point: "จุดปัจจุบัน",
  free_room: "ห้องฟรี",
  last_join_time: "เวลาเข้าร่วมล่าสุด",
  archery: "ยิงธนู",
  winter_olympic: "โอลิมปิกฤดูหนาว",
  no1: "ผู้ชนะอันดับที่ 1",
  adjustment: "การปรับตัว",
  poker: "โป๊กเกอร์",
  poker_db: "DB Poker",
  yellow: "สีเหลือง",
  blue: "สีน้ำเงิน",
  first_ball: "ลูกบอลแรก",
  best_5_balls: "5 ลูกที่ดีที่สุด",
  binary_allin: "Binary"
};
